module.exports = __webpack_public_path__ + "static/media/Bunk-bed-2.ff0b00e5.jpg";